module.exports = __webpack_public_path__ + "resources/img/img_secure_center01_m.5b42f92e42fdaace2b5495203612a3d1.png";